import React from 'react';

import {
  TableRow,
  TitleTableCell,
} from 'components/Overview/BreakdownTable/styles';
import CustomerIcon from 'components/base/CustomerIcon/CustomerIcon';
import DoubleMetricCell from 'components/data-visualization/Table/DoubleMetricCell';
import { IMetric } from 'maps/metrics';

export interface IBreakdownTableRowProps {
  withIcon?: boolean;
  row: any;
  activeMetric: IMetric;
}

const BreakdownTableRow: React.FC<IBreakdownTableRowProps> = (props) => {
  const { withIcon, row, activeMetric } = props;

  return (
    <TableRow key={row.label} isRightAligned>
      <TitleTableCell>
        {withIcon && (
          <CustomerIcon
            showHiddenPlaceholder
            aria-hidden
            customer={row.customerValue}
          />
        )}
        {row.label}
      </TitleTableCell>
      <DoubleMetricCell
        entityData={row.values}
        header={activeMetric}
        sortBy={activeMetric}
      />
    </TableRow>
  );
};

export default BreakdownTableRow;
